import React from "react";

import type { PopupKey } from "@performyard/service-contracts";

import { PopupCard } from "./PopupCard";

import { useDismissPopup, usePopupDismissed } from "../../../api/hooks";

type DismissiblePopupProps = {
	popupKey: PopupKey;
	enabled: boolean;
	title: string;
	action?: {
		label: string;
		onClick: () => void;
	};
};

/**
 * Callout above the Ask PerformYard trigger, shown on every visit while `enabled`
 * until the user dismisses it with the x (dismissal persisted per-user, keyed by `popupKey`).
 */
export const DismissiblePopup: React.FC<DismissiblePopupProps> = ({ popupKey, enabled, title, action }) => {
	const { data } = usePopupDismissed(popupKey, enabled);
	const { mutate: dismiss } = useDismissPopup(popupKey);

	if (!enabled || data?.dismissed !== false) {
		return null;
	}

	return (
		<div className="hide-in-pdf fixed right-6 bottom-24 z-[1099] w-[280px]">
			<PopupCard title={title} action={action} onDismiss={() => dismiss()} />
		</div>
	);
};

export default DismissiblePopup;
